// 使用画布逻辑像素；不按比例缩放组件内部配置。
export function componentSize (size = {}, canvas = {}) {
  return ['width', 'height'].reduce((result, axis) => {
    const value = Number(size[axis]), limit = Number(canvas[axis])
    result[axis] = Math.min(Number.isFinite(limit) && limit >= 1 ? limit : Infinity,
      Number.isFinite(value) ? Math.max(1, value) : 1)
    return result
  }, {})
}

// 仅在新增或用户缩小画布时调用；读取旧项目、预览和恢复历史不做迁移。
export function limitNodeBounds (nodes, canvas = {}, set = (object, key, value) => { object[key] = value }) {
  (nodes || []).forEach(node => {
    if (Array.isArray(node.children)) limitNodeBounds(node.children, canvas, set)
    else if (node.component) {
      const rect = componentRect({ ...node.component, left: node.left, top: node.top }, canvas)
      ;[['width', 'left'], ['height', 'top']].forEach(([axis, position]) => {
        if (!Number.isFinite(Number(canvas[axis])) || Number(canvas[axis]) < 1) return
        if (node.component[axis] !== rect[axis]) set(node.component, axis, rect[axis])
        if (node[position] !== rect[position]) set(node, position, rect[position])
      })
    }
  })
}

export function componentRect (rect, canvas = {}) {
  const size = componentSize(rect, canvas), result = { ...rect, ...size }
  ;[['left', 'width'], ['top', 'height']].forEach(([position, axis]) => {
    const value = Number(rect[position]), limit = Number(canvas[axis])
    if (Number.isFinite(limit) && limit >= 1) result[position] = Math.max(0, Math.min(Number.isFinite(value) ? value : 0, limit - size[axis]))
  })
  return result
}

// 左/上拉伸到上限后保留对边锚点，避免尺寸受限了但位置仍随鼠标漂移。
export function resizedComponentRect (rect, canvas = {}, direction = '') {
  const result = componentRect(rect, canvas)
  ;[['left', 'right', 'width'], ['top', 'bottom', 'height']].forEach(([position, end, axis]) => {
    const limit = Number(canvas[axis])
    if (!Number.isFinite(limit) || limit < 1) return
    if (direction.includes(position)) {
      const anchor = Math.max(1, Math.min(limit, Number(rect[position]) + Number(rect[axis])))
      result[position] = Math.max(0, Math.min(Number(rect[position]), anchor - 1))
      result[axis] = anchor - result[position]
    } else if (direction.includes(end)) {
      result[position] = Math.max(0, Math.min(Number(rect[position]) || 0, limit - 1))
      result[axis] = Math.min(componentSize(rect, canvas)[axis], limit - result[position])
    }
  })
  return result
}
